export enum EmploymentAgreementProcessStep {
  BasicInformations = 1,
  WageParameters = 2,
  Insurance = 3,
  Summary = 4,
}
